import { TRUEGATE_SUBDOMAIN } from "./getTruegateHostUrl";

const SUBDOMAINS_TO_STRIP = [TRUEGATE_SUBDOMAIN];

export const getCurrentRootDomain = () => {
    if (typeof window === "undefined") return "";
    const url = new URL(window.location.href);
    const parts = url.hostname.split(".");
    if (parts.length > 2 && SUBDOMAINS_TO_STRIP.includes(parts[0])) {
        parts.shift();
    }
    const rootHost = parts.join(".");
    const port = url.port ? `:${url.port}` : "";
    return `${url.protocol}//${rootHost}${port}`;
};

